import React, { useState } from 'react';
import { TabMenu } from 'primereact/tabmenu';
import GlobalLoader from 'components/GlobalLoader/GlobalLoader';
import Header from './Header';
import Table from './Table';
import CaptureNowTable from './CaptureNowTable';

export default function OnlineLeadsList() {
  const [activeIndex, setActiveIndex] = useState(0);

  const tabItems = [{ label: 'Online Forms' }, { label: 'CaptureNow' }];

  return (
    <div className="container-fluid online-lead-list-page">
      <GlobalLoader />
      <Header title="Online Leads List" />

      <TabMenu model={tabItems} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} />

      {activeIndex === 0 && (
        <div className="col-12 datatable-responsive card-bg mb-3 intake-form-table">
          <Table />
        </div>
      )}

      {activeIndex === 1 && (
        <div className="col-12 datatable-responsive card-bg mb-3 intake-form-table">
          <CaptureNowTable />
        </div>
      )}
    </div>
  );
}
